import Localization from 'lib/localization';

export default {
    lxBlockTitle() {
        return `Welcome to Safety Centre`;
        // return Localization.get('badoo_safety_center@hero_block.title');
    },
    lxVideoStubA11yLabel() {
        return Localization.get('badoo_safety_center@intro.video.stub.a11y.title');
    },
};
